import React from 'react';
import { Flex, Spinner, Text, Box, Skeleton, SkeletonText } from '@chakra-ui/react';

export default function LoadingState({ title = 'Loading...', subtitle = '', minH = '40vh', showSkeleton = false }) {
  return (
    <Flex align="center" justify="center" minH={minH} direction="column" gap={4} bg="gray.50">
      <Spinner size="xl" thickness="5px" color="green.400" speed="0.7s" />
      <Text fontSize="lg" color="gray.600" fontWeight="semibold">{title}</Text>
      {subtitle ? <Text fontSize="sm" color="gray.500">{subtitle}</Text> : null}
      {showSkeleton && (
        <Box w="100%" maxW="960px" bg="white" borderRadius="xl" boxShadow="md" p={6}>
          <Skeleton height="32px" width="40%" mb={6} />
          <SkeletonText noOfLines={6} spacing="4" skeletonHeight="20px" />
        </Box>
      )}
    </Flex>
  );
}


